import { render, staticRenderFns } from "./EmpleadoBonos.vue?vue&type=template&id=a7ca31d0&"
import script from "./EmpleadoBonos.vue?vue&type=script&lang=js&"
export * from "./EmpleadoBonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports